import { useState, useCallback, ReactNode } from 'react';
import ReactDOM from 'react-dom';

export interface TooltipProps {
  children: ReactNode;
  isDisabled?: boolean;
  tooltipContent: ReactNode;
  position?: 'top' | 'bottom';
}

const Tooltip: React.FC<TooltipProps> = ({
  children,
  isDisabled = false,
  tooltipContent,
  position = 'bottom'
}: TooltipProps) => {
  const [tooltipPosition, setTooltipPosition] = useState<{
    top: number;
    left: number;
  } | null>(null);

  const handleMouseEnter = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      const rect = event.currentTarget.getBoundingClientRect();
      setTooltipPosition({
        top:
          position === 'top'
            ? rect.top + window.scrollY - 8
            : rect.bottom + window.scrollY + 8,
        left: rect.left + window.scrollX
      });
    },
    [position]
  );

  const handleMouseLeave = useCallback(() => {
    setTooltipPosition(null);
  }, []);

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="relative inline-block"
    >
      {children}
      {tooltipPosition &&
        ReactDOM.createPortal(
          <div
            className="absolute  bg-black border text-white  rounded transition-all z-30  p-2 shadow-md text-sm pointer-events-none"
            style={{
              top: `${tooltipPosition.top}px`,
              left: `${tooltipPosition.left}px`,
              position: 'absolute'
            }}
          >
            <div className="relative">
              {tooltipContent}
              {/* Arrow */}
              <div
                className={`absolute left-1/2 -translate-x-1/2 ${
                  position === 'top' ? '-bottom-2' : '-top-2'
                } w-4 h-4 border-l-8 border-l-transparent border-r-8 border-r-transparent border-t-8 border-t-black`}
              />
            </div>
          </div>,
          document.body
        )}
    </div>
  );
};

export default Tooltip;
